// extracted by mini-css-extract-plugin
export default {"wrapper":"expand_wrapper__aZtVO","titleWrapper":"expand_titleWrapper__bcb08","expandWrapper":"expand_expandWrapper__9c+5u"};